import { Component, EventEmitter, inject, Input, Output, signal } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'AMore-sdk-ad-media-view',
  imports: [],
  templateUrl: './ad-media-view.component.html',
  styleUrl: './ad-media-view.component.scss'
})
export class AdMediaViewComponent {
  public count = signal<number>(0);
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter<any>();
  @Input() adData: any = {} as any;
  @Input() index: number = 0;

  isPaused: boolean = false;
  isAdClosed: boolean = false;
  rewarded: boolean = false;
  impressionTracked: boolean = false;


  urlsanitizer = inject(DomSanitizer);
  ngOnInit() {
    this.isAdClosed = false;
    this.startCountdown();
  }

  startCountdown() {
    setTimeout(() => {
      this.count.update(value => value + 2);
      this.onClickEvent(null, 'on_ad_progress');
      if (!this.isPaused) {
        this.startCountdown(); // Recursive call
      }
    }, 2000);
  }

  public onClickEvent(event: any, action: string) {
    switch (action) {
      case 'on_ad_click':
        this.onChangeEvent.emit({ action: action, progress: this.count(), data: { url: this.adData.ads[this.index].clickUrl, action: "open_url" } });
        break;
      case 'on_ad_closed':
        this.isAdClosed = true;
        this.onChangeEvent.emit({ action: action, progress: this.count(), data: { ...this.adData } });
        break;
      case 'on_ad_progress':
        this.onChangeEvent.emit({ action: action, progress: this.count(), data: {} });
        break;
      case 'on_ad_resumed':
        this.onChangeEvent.emit({ action: action, progress: this.count(), data: {} });
        break;
      case 'on_ad_paused':
        this.onChangeEvent.emit({ action: action, progress: this.count(), data: {} });
        break;
      case 'on_ad_skip':
        this.onChangeEvent.emit({ action: action, progress: this.count(), data: {} });
        break;
      case 'on_ad_collect_reward':
        this.onChangeEvent.emit({ action: action, progress: this.count(), data: {} });
        break;
      case 'on_ad_impression':
        this.onChangeEvent.emit({ action: action, progress: this.count(), data: {} });
        break;
      default:
        this.onChangeEvent.emit({ action: action, progress: this.count(), data: {} });
        break;
    }

    // reward at percentage
    if (this.count() >= (this.adData.ads[this.index].creative.rewardPercentage / 100) * 5 && !this.rewarded) {
      this.rewarded = true;
      this.onChangeEvent.emit({ action: 'on_ad_collect_reward', data: { reward: +this.adData.ads[this.index].creative.rewardPercentage + '%' } });
    }
    // impression at 2s
    if (this.count() >= 2 && !this.impressionTracked) {
      this.impressionTracked = true;
      this.onClickEvent(null, 'on_ad_impression');
    }

  }
  pauseImg() {
    this.isPaused = true;
    this.onClickEvent(null, 'on_ad_paused');
  }

  playImg() {
    if (this.isPaused && !this.isAdClosed) {
      this.isPaused = false;
      this.onClickEvent(null, 'on_ad_resumed');
      this.startCountdown();
    }
  }

  getSafeUrl(url: string) {
    return this.urlsanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
